"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitMeterReadingForm = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var __generated__1 = require("../../../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var components_1 = require("../../../../components");
var copy_1 = require("../../../../copy");
var utils_1 = require("../../../../utils");
var SubmitMeterReadingForm = function (_a) {
    var _b;
    var currentSupply = _a.currentSupply, onSubmit = _a.onSubmit, onError = _a.onError, isLoading = _a.isLoading, date = _a.date;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _c.Copy, copy = _c.copy;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _d = (0, core_1.useComponents)(), PrimaryCTAButton = _d.PrimaryCTAButton, Stack = _d.Stack, NumberField = _d.NumberField, Heading2 = _d.Heading2, Heading3 = _d.Heading3;
    var _e = __read((0, react_1.useState)([]), 2), errors = _e[0], setErrors = _e[1];
    var readings = currentSupply.readings, registers = currentSupply.registers;
    var latestActualReading = (0, utils_1.getLatestActualReading)(readings);
    var activeRegisters = (0, utils_1.filterRegistersByDate)(registers, new Date((0, utils_1.getReadingDateTime)(date)));
    // dynamically set keys for state
    var registerIds = activeRegisters.reduce(function (initialState, register) {
        var _a;
        return (__assign(__assign({}, initialState), (_a = {}, _a[register.registerId] = '', _a)));
    }, {});
    var _f = __read((0, react_1.useState)(registerIds), 2), meterReading = _f[0], setMeterReading = _f[1];
    var onMeterReadingChange = function (label) { return function (_a) {
        var _b;
        var meterReadingVal = _a.currentTarget.value;
        setMeterReading(__assign(__assign({}, meterReading), (_b = {}, _b[label] = meterReadingVal, _b)));
    }; };
    var handleSubmit = function (event) {
        var _a;
        var _b;
        event.preventDefault();
        setErrors([]);
        onError([]);
        var errors = [];
        var newRegisters = activeRegisters.map(function (register) {
            var validation = (0, utils_1.validateInput)(meterReading[register.registerId]
                ? Number(meterReading[register.registerId])
                : null, currentSupply.meterNumOfDigits);
            if (validation === null || validation === void 0 ? void 0 : validation.message) {
                errors.push({
                    id: register.registerId,
                    message: copy(validation.message, {
                        numOfDigits: currentSupply.meterNumOfDigits,
                    }),
                });
            }
            return __assign(__assign({}, register), { value: meterReading[register.registerId] });
        });
        var lastMexDate = (_b = (0, utils_1.getLatestMeterExchangeReading)(readings)) === null || _b === void 0 ? void 0 : _b.formattedReadingDate;
        var dateError = (0, utils_1.validateDate)((0, utils_1.getReadingDateTime)(date || new Date().toISOString()), currentSupply.startDate, lastMexDate);
        if (dateError === null || dateError === void 0 ? void 0 : dateError.message) {
            errors.push({
                id: 'date',
                message: copy(dateError.message),
            });
        }
        if (errors.length) {
            setErrors(errors);
            onError(errors);
            dispatch({
                name: analytics_subjects_1.METER_READ_SUBMIT_ERROR,
                type: 'render',
                properties: (_a = {
                        errors: errors
                    },
                    _a[core_1.INTERNAL_EVENT_FLAG] = true,
                    _a[analytics_subjects_1.KAPI_ONLY] = true,
                    _a),
            });
        }
        else {
            var submissionData = {
                sprn: currentSupply.sprn,
                fuel: currentSupply.fuel,
                meterSerialNumber: currentSupply.msn,
                dateTime: (0, utils_1.getReadingDateTime)(date),
                registers: newRegisters,
                force: __generated__1.MeterReadForceType.NoForce,
            };
            onSubmit(submissionData);
        }
    };
    return (react_1.default.createElement("form", { "data-testid": "".concat(currentSupply.fuel, "-meter-reading-form"), onSubmit: handleSubmit, method: "POST", noValidate: true },
        react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
            activeRegisters.map(function (_a) {
                var timeOfUseLabel = _a.timeOfUseLabel, registerId = _a.registerId;
                var idLabel = timeOfUseLabel
                    ? timeOfUseLabel
                    : registerId === 'gas'
                        ? registerId
                        : '';
                var lastReadingValue = latestActualReading
                    ? (0, utils_1.getReadValue)({
                        registerId: registerId,
                        reading: latestActualReading,
                        timeOfUseLabel: timeOfUseLabel !== null && timeOfUseLabel !== void 0 ? timeOfUseLabel : undefined,
                        meterNumOfDigits: currentSupply.meterNumOfDigits,
                    })
                    : undefined;
                return (react_1.default.createElement(Stack, { spaceBetween: 2, key: "stack-".concat(idLabel) },
                    currentSupply.fuel === 'electricity' && timeOfUseLabel && (react_1.default.createElement(Heading2, { as: Heading3, "data-testid": "meter-reading-electricity-heading" },
                        react_1.default.createElement(Copy, { copyKey: "submitMeterReadingRegisterHeading", values: {
                                timingCategory: copy(timeOfUseLabel),
                            } }))),
                    react_1.default.createElement(components_1.RegisterReading, { "data-testid": "register-summary-".concat(idLabel), timeOfUseLabel: timeOfUseLabel, date: latestActualReading === null || latestActualReading === void 0 ? void 0 : latestActualReading.formattedReadingDate, meterReading: lastReadingValue, isNew: false },
                        react_1.default.createElement(NumberField, { id: registerId, "data-testid": "meter-reading-".concat(registerId), label: copy('submitMeterReadingInputLabel'), value: meterReading[registerId], onChange: onMeterReadingChange(registerId), hint: copy('submitMeterReadingInputHintText'), error: (0, nebula_1.getErrorMessage)(registerId, errors), characters: 10, disabled: isLoading }))));
            }),
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SUBMIT_METER_READING, properties: (_b = {},
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b[analytics_subjects_1.KAPI_ONLY] = true,
                    _b.meterData = (0, utils_1.getMeterReadAnalyticsData)(currentSupply, currentSupply.fuel),
                    _b.backdatedDays = (0, utils_1.getBackdatedDaysToToday)(date),
                    _b.datepickerEntry = date,
                    _b) },
                react_1.default.createElement(PrimaryCTAButton, { type: "submit", "data-testid": "submit-meter-reading", disabled: isLoading },
                    react_1.default.createElement(Copy, { copyKey: "submitMeterReadingSubmitLabel" }))))));
};
exports.SubmitMeterReadingForm = SubmitMeterReadingForm;
